import React, { useEffect, useState } from 'react';
import { Users, Ticket, ShoppingCart } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface UrgencyBannerProps {
  spots: number;
  onSale: () => void;
  viewers: number;
}
export function UrgencyBanner({
  spots,
  onSale,
  viewers
}: UrgencyBannerProps) {
  const [isSticky, setIsSticky] = useState(false);
  const [recentSale, setRecentSale] = useState({
    show: false,
    text: ''
  });
  useEffect(() => {
    const handleScroll = () => {
      const purchaseSection = document.getElementById('purchase');
      if (purchaseSection) {
        const rect = purchaseSection.getBoundingClientRect();
        // Aparece sticky cuando la sección de compra está cerca de entrar o ya entró
        setIsSticky(rect.top <= 100);
      }
    };
    window.addEventListener('scroll', handleScroll);
    const sales = ['1 cupón vendido hace 5 mins', 'Nuevo acceso desde Mendoza hace 2 min', '1 cupón reservado hace instantes'];
    let saleTimeout: NodeJS.Timeout;
    const triggerSale = () => {
      const randomTime = Math.floor(Math.random() * (25000 - 15000 + 1)) + 15000;
      saleTimeout = setTimeout(() => {
        setRecentSale({
          show: true,
          text: sales[Math.floor(Math.random() * sales.length)]
        });
        onSale();
        setTimeout(() => {
          setRecentSale({
            show: false,
            text: ''
          });
        }, 4000);
        triggerSale();
      }, randomTime);
    };
    triggerSale();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(saleTimeout);
    };
  }, []);
  return <>
      {/* Floating Notification (When NOT sticky) */}
      <AnimatePresence data-id="element-399">
        {!isSticky && recentSale.show && <motion.div initial={{
        opacity: 0,
        x: -20,
        y: 20,
        scale: 0.9
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.9,
        transition: {
          duration: 0.2
        }
      }} className="fixed bottom-6 left-6 z-[60] bg-white/40 backdrop-blur-2xl text-violet-950 p-1.5 rounded-full shadow-[0_8px_32px_0_rgba(139,92,246,0.2),inset_0_0_0_1px_rgba(255,255,255,0.4)] border border-white/20 flex items-center gap-2.5 max-w-[280px] overflow-hidden" data-id="element-400">
            {/* Glossy Shine Effect */}
            <div className="absolute inset-0 bg-gradient-to-tr from-white/20 via-white/40 to-transparent pointer-events-none" data-id="element-401" />

            <div className="w-7 h-7 bg-violet-600 rounded-full flex items-center justify-center text-white shrink-0 relative z-10 shadow-lg shadow-violet-500/30" data-id="element-402">
              <ShoppingCart size={12} data-id="element-403" />
            </div>
            <div className="relative z-10 pr-3 py-0.5" data-id="element-404">
              <p className="text-[8px] font-black text-violet-600 uppercase tracking-[0.15em] leading-none mb-0.5 opacity-80" data-id="element-405">
                Venta Reciente
              </p>
              <p className="font-bold text-[11px] leading-tight tracking-tight" data-id="element-406">
                {recentSale.text}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Sticky Banner */}
      <motion.div initial={false} animate={{
      y: isSticky ? 0 : -100,
      opacity: isSticky ? 1 : 0
    }} className="py-2 fixed top-0 left-0 w-full z-50 transition-all duration-500" data-id="element-407">
        <div className="max-w-5xl mx-auto px-4" data-id="element-408">
          <div className="relative overflow-hidden rounded-full border border-white/30 bg-white/70 backdrop-blur-xl shadow-[0_8px_32px_0_rgba(31,38,135,0.15)] px-6 py-2 flex flex-wrap justify-center items-center text-violet-950 font-black uppercase tracking-tighter pt-[0px] pb-[0px] pl-[24px] pr-[24px] gap-[5px]" data-id="element-409">
            {/* Glossy Shine Effect */}
            <div className="absolute inset-0 bg-gradient-to-b from-white/40 to-transparent pointer-events-none" data-id="element-410" />

            <div className="flex text-[12px] font-[700] gap-[6px] flex-row items-center justify-start relative z-10" data-id="element-411">
              <span className="relative flex h-2 w-2" data-id="element-412">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-75" data-id="element-413"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-414"></span>
              </span>
              <Users size={14} className="text-violet-600" data-id="element-415" />
              {viewers} PERSONAS MIRANDO
            </div>

            <motion.div animate={{
            opacity: [1, 0.7, 1]
          }} transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'linear'
          }} className="flex items-center gap-2 font-[700] text-[12px] relative z-10" data-id="element-416">
              <span className="relative flex h-2 w-2" data-id="element-417">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-418"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-419"></span>
              </span>
              <Ticket size={14} className="text-violet-600" data-id="element-420" />
              CUPOS DISPONIBLES:{' '}
              <motion.span key={spots} initial={{
              scale: 1.4,
              color: '#ef4444'
            }} animate={{
              scale: 1,
              color: 'inherit'
            }} transition={{
              duration: 0.4
            }} className="inline-block ml-1" data-id="element-421">
                {spots}
              </motion.span>
            </motion.div>

            {/* Integrated Notification (When sticky) */}
            <AnimatePresence data-id="element-422">
              {isSticky && recentSale.show && <motion.div initial={{
              opacity: 0,
              scale: 0.9,
              x: 20
            }} animate={{
              opacity: 1,
              scale: 1,
              x: 0
            }} exit={{
              opacity: 0,
              scale: 0.9,
              x: 20
            }} className="flex items-center gap-2 bg-violet-600 text-white px-4 py-1 rounded-full font-bold text-[10px] shadow-lg relative z-10" data-id="element-423">
                  <ShoppingCart size={12} data-id="element-424" />
                  {recentSale.text}
                </motion.div>}
            </AnimatePresence>
          </div>
        </div>
      </motion.div>
    </>;
}